<template>
  <div class="drug-info contant-wrap">
    <div class="filter-data">
      <h3>流向查询</h3>
      <div class="filter-control">
        <el-row>
          <el-col :span="11">
            <div class="rows">
              <label for="">出入库时间：</label>
              <el-date-picker
                v-model="time"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="getTableData(1)"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="rows">
              <label for="">出入库类型：</label>
              <el-select v-model="query.reasonType" placeholder="请选择" @change="getTableData(1)">
                <el-option
                  v-for="item in reasonIdList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="rows rows-last">
              <div class="fix-wrap">
                <his-autocomplete-suggestions 
                :fetch-suggestions="querySearch"
                pointKey="drugName"
                :value.sync="query.drugName"
                showSearch
                @searchHandle="searchHandel"
                @selectHandle="selectHandle"
                @input.native="checkDrug"
                placeholder="药品名/条码/厂商"
                :isShopDrugs="isShopDrugs === 1"
                class="container">
                  <template slot-scope="slotProps">
                    <div class="search-item">
                      <div>
                        <img src="../../../assets/images/logo-l.png" class="logo-img"  v-if="slotProps.item.isShopDrugs === 1"/>
                        {{slotProps.item.drugName}}
                      </div>
                      <div> {{slotProps.item.specification}} </div>
                      <div> {{slotProps.item.manufacturer}} </div>
                    </div>
                  </template>
                </his-autocomplete-suggestions>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="6">
            <div class="rows">
              <el-input placeholder="单号" v-model="query.oddNumbers">
                <el-button slot="append" icon="el-icon-search" @click="getTableData(1)"></el-button>
              </el-input>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="rows">
              <el-input placeholder="批号" v-model="query.drugbatchNo">
                <el-button slot="append" icon="el-icon-search" @click="getTableData(1)"></el-button>
              </el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows">
              <el-button type="success" class="button" @click="fileExport">导出</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows rows-last">
              <select-col-table :select-options="rowList" @change="getTableCol"></select-col-table>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-table :data="drugsList" :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}" v-loading="isLoading" style="width: 100%" class="table">
      <el-table-column prop="date" label="日期" sortable min-width="140">
      </el-table-column>
      <el-table-column prop="drugId" label="药品ID">
      </el-table-column>
      <el-table-column prop="drugName" label="药品名称" sortable  min-width="100">
        <template slot-scope="scope">
          <img src="../../../assets/images/logo-l.png" class="logo-img"  v-if="scope.row.isShopDrugs === 1"/>
          {{scope.row.drugName}}
        </template>
      </el-table-column>
      <el-table-column prop="drugTypeName" label="药品类型">
      </el-table-column>
      <el-table-column prop="specification" label="规格"  min-width="100">
      </el-table-column>
      <el-table-column prop="manufacturer" label="厂家" min-width="140">
      </el-table-column>
      <el-table-column
        prop="approvalNumber"
        label="批准文号">
      </el-table-column>
      <el-table-column
        v-for="item in rowList"
        :key="item.value"
        :prop="item.value"
        :label="item.name"
        :min-width="item.minWidth"
        :sortable="item.isSortable"
        v-if="item.checked">
          <template slot-scope="scope">
            <!-- <template  v-if="item.value == 'oddNumbers'">
              {{scope.row.oddNumbers}}
            </template> -->
            <template  v-if="item.value == 'changeNumbers'">
              {{scope.row.reasonType | setReasonType}}{{scope.row.changeNumbers}}
            </template>
            <template  v-if="item.value == 'inventoryCountNow'">
              {{scope.row.inventoryCountNow}}
            </template>
            <template  v-if="item.value == 'modifier'">
              {{scope.row.modifier}}
            </template>
            <template  v-if="item.value == 'drugBatchNo'">
              {{scope.row.drugBatchNo}}
            </template>
            <template  v-if="item.value == 'validityDate'">
              {{scope.row.validityDate}}
            </template>
            <template  v-if="item.value == 'purchasePrice'">
              {{scope.row.purchasePrice}}
            </template>
            <template  v-if="item.value == 'salePrice'">
              {{scope.row.salePrice}}
            </template>
            <template  v-if="item.value == 'goodsShelfCode'">
              {{scope.row.goodsShelfCode}}
            </template>
          </template>
      </el-table-column>
  </el-table>
  <div class="pagination" v-if="drugsList.length > 0">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="query.currentPage"
      :page-sizes="pageSizes"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
  </div>
</template>

<script>
import SelectColTable from '@/components/SelectColTable.vue';
import { pageSizes, pickerOptions, reasonIdList } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import config from '@/config/index';
import { startDate } from '@/utils/filter';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';

export default {
  name: 'flow-query',
  components: { SelectColTable, HisAutocompleteSuggestions },
  mixins: [pageSize],
  data() {
    return {
      pageSizes,
      pickerOptions,
      reasonIdList,
      drugsList: [], // 药品列表
      total: 0, // 总数据条数
      isLoading: false,
      input: '',
      time: [],
      query: {
        reasonType: -1, // 出入库类型
        // oddNumbers: '', // 单号
        drugName: '', // 药品名
        drugbatchNo: '', // 药品批号
        searchContent: '', // 搜索内容（药品名称/单号/批号）
        startTime: '',
        endTime: '',
        currentPage: 1, // 页码 从1开始
        pageSize: 20, // 每页数据条数
        drugId: '', // 药品id
      },
      value: '',
      rowList:
      [
        {
          name: '出入库-数量',
          value: 'changeNumbers',
          minWidth: '100',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '实时数量',
          value: 'inventoryCountNow',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '操作人',
          value: 'modifier',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '批号',
          value: 'drugBatchNo',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '有效期',
          value: 'validityDate',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '进货价',
          value: 'purchasePrice',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '零售价',
          value: 'salePrice',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '货架码',
          value: 'goodsShelfCode',
          minWidth: '88',
          isSortable: true,
          disabled: false,
          checked: true,
        },
      ],
      isShopDrugs: 0,
    };
  },
  created() {
    this.query.drugId = this.$route.query.drugId || '';
  },
  mounted() {
    this.time = startDate(); // 设置默认日期
    this.getTableData(1);
  },
  methods: {
    // 获取药品列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      if (this.time) {
        this.query.startTime = this.time[0];
        this.query.endTime = this.time[1];
      } else {
        this.query.startTime = '';
        this.query.endTime = '';
      }
      this.$api.drugControl.flow(this.query).then((res) => {
        this.drugsList = res.drugsList || [];
        this.total = res.totalSize || 0;
      });
    },
    // 导出
    fileExport() {
      if (this.drugsList.length < 1) {
        this.$alert('没有药品信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.$api.drugControl.flowExport(this.query);
      }
    },
    // 药品名称检索
    querySearch(str, cb) {
      this.isShopDrugs = 0;
      this.$api.drugControl.drugsNameList({ drugName: str }).then((res) => {
        if (Array.isArray(res.drugList) && res.drugList.length > 0) {
          cb(res.drugList);
        } else {
          cb([]);
        }
      });
    },
    // 选择药品名称
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.query.drugId = e.id;
      this.isShopDrugs = e.isShopDrugs;
      this.getTableData(1);
    },
    // 清空药品id
    checkDrug() {
      this.query.drugId = '';
    },
    // 点击搜索
    searchHandel(e) {
      this.query.drugName = e;
      this.getTableData(1);
    },
    // 每页展示数据条数变更
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(e) {
      this.query.currentPage = e;
      this.getTableData();
    },
    getTableCol(e) {
      this.rowList = e;
    },
  },
  filters: {
    setReasonType(val) {
      if (!val) return '';
      const { label } = reasonIdList.find(item => item.value == val);
      return label;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input-group{
  width: 80%;
}
</style>
